import React, { Component } from 'react';
import _ from 'lodash';

import NextPostBtn from '../components/Pages/NextPostBtn';

export default class NextPost extends Component {
    getPost() {
        if (this.props.next === 'next') {
            return this.getNextPost();
        } else {
            return this.getPrevPost();
        }
    }

    getNextPost() {
        if (this.props.nextposts) {
            const currentIndex = _.findIndex(this.props.nextposts, [
                'slug',
                this.props.slug,
            ]);
            const nextIndex = currentIndex + 1;
            if (this.props.nextposts[nextIndex]) {
                return this.props.nextposts[nextIndex];
            } else {
                return false;
            }
        }
    }

    getPrevPost() {
        if (this.props.nextposts) {
            const currentIndex = _.findIndex(this.props.nextposts, [
                'slug',
                this.props.slug,
            ]);
            const nextIndex = currentIndex - 1;
            if (this.props.nextposts[nextIndex]) {
                return this.props.nextposts[nextIndex];
            } else {
                return false;
            }
        }
    }

    render() {
        return <NextPostBtn next={this.props.next} nextpost={this.getPost()} />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/NextPost.jsx